// export this package's api
import Align from './Align';
export default Align;